"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const execute_1 = require("./execute");
const drawPixels_1 = require("./drawPixels");
const ws2812_1 = require("./ws2812");
const MHZ = 16000000;
class LEDuino {
    constructor({ rows = 14, cols = 14, canvas = undefined, serpentine = true, hex = '', onPixels = undefined, onSerial = undefined, coordinates = undefined, }) {
        this.cpuNanos = () => Math.round((this.runner.cpu.cycles / MHZ) * 1000000000);
        this.listener = () => {
            this.matrixController.feedValue(this.runner.portB.pinState(6), this.cpuNanos());
        };
        this.stop = () => {
            var _a;
            (_a = this.runner) === null || _a === void 0 ? void 0 : _a.stop();
        };
        this.start = () => {
            var _a;
            (_a = this.runner) === null || _a === void 0 ? void 0 : _a.execute((_cpu) => {
                const pixels = this.matrixController.update(this.cpuNanos());
                if (!pixels)
                    return;
                const pixelsToDraw = [];
                for (let i = 0; i < pixels.length; i++) {
                    const value = pixels[i];
                    let x, y;
                    if (this.coordinates) {
                        const coordinates = this.coordinates[i];
                        [x, y] = coordinates;
                    }
                    else {
                        const col = i % this.cols;
                        const row = Math.floor(i / this.cols); // - col;
                        x = col;
                        if (this.serpentine)
                            x = row % 2 ? this.cols - col - 1 : col;
                        y = row;
                    }
                    pixelsToDraw.push({
                        x,
                        y,
                        b: value & 0xff,
                        r: (value >> 8) & 0xff,
                        g: (value >> 16) & 0xff,
                    });
                }
                if (this.canvas) {
                    drawPixels_1.drawPixels(pixelsToDraw, this.canvas, this.rows, this.cols, this.serpentine, this.coordinates);
                }
                if (this.onPixels) {
                    this.onPixels(pixelsToDraw);
                }
            });
        };
        this.rows = rows;
        this.cols = cols;
        this.canvas = canvas;
        this.onPixels = onPixels;
        this.onSerial = onSerial;
        this.serpentine = serpentine;
        this.hex = hex;
        this.coordinates = coordinates;
    }
    set hex(newHex) {
        var _a, _b;
        if (newHex === this._hex)
            return;
        (_a = this.runner) === null || _a === void 0 ? void 0 : _a.portB.removeListener(this.listener);
        (_b = this.runner) === null || _b === void 0 ? void 0 : _b.stop();
        this._hex = newHex;
        this.runner = new execute_1.AVRRunner(this._hex);
        this.matrixController = new ws2812_1.WS2812Controller(this.cols * this.rows);
        this.runner.portB.addListener(this.listener);
        this.runner.usart.onByteTransmit = (value) => {
            this.onSerial && this.onSerial(String.fromCharCode(value));
        };
        this.start();
    }
}
exports.default = LEDuino;
